import { useState, useCallback } from 'react'
import { Button, SpacingToken } from '@livechat/design-system-react-components'
import { css } from '@emotion/react'

import { notificationsCreate } from '@/store/notifications'
import { useTypedDispatch } from '@/store/hooks'
import { NOTIFICATIONS, ToastKind } from '@/constants'
import { useOneClickPaymentContext } from '@/context/OneClickPayment'
import useParamSelector from '@/hooks/useParamSelector'
import { getPaymentItem } from '@/store/selectors'
import { useOnboarding } from '@/context/OnboardingContext'
import { handleDirectInstallationUrlFlow } from '@/utils/products'

const footerWrapperCss = css`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: var(${SpacingToken.Spacing2});
`

const ActivateProductModalFooter = () => {
  const dispatch = useTypedDispatch()
  const { closeModal } = useOneClickPaymentContext()

  const [isActivating, setIsActivating] = useState(false)
  const item = useParamSelector(getPaymentItem)
  const { checkOnboarding } = useOnboarding()

  const handleClose = useCallback(() => {
    dispatch(
      notificationsCreate({
        kind: ToastKind.Success,
        content: 'Application activated successfully!',
        autoHideDelayTime: NOTIFICATIONS.AUTO_HIDE_DELAY_TIME,
      })
    )
    checkOnboarding()
    closeModal()
    return null
  }, [checkOnboarding, closeModal, dispatch])

  const activateProduct = useCallback(() => {
    if (!item) return

    setIsActivating(true)

    handleDirectInstallationUrlFlow({
      clientId: item.authorization?.clientId,
      directInstallUrl: item?.directInstallUrl,
      name: item.name,
      openInNewTab: false,
      onClose: handleClose,
    })
  }, [item, handleClose])

  return (
    <div css={footerWrapperCss}>
      <Button kind="secondary" onClick={closeModal}>
        Cancel
      </Button>
      <Button
        kind="primary"
        loading={isActivating}
        loaderLabel="Activating..."
        onClick={activateProduct}
      >
        Activate app
      </Button>
    </div>
  )
}

export default ActivateProductModalFooter
